import { useQuery } from '@tanstack/react-query';
import type { ColumnSort } from '@tanstack/react-table';

import { DEFAULT_PAGE_SIZE } from '../components/constants';
import { getArtistTracks } from '../lib/tracks';
import { formatArtistTracksSortBy } from '../lib/utils';

interface ArtistTracksQueryProps {
  uaid?: number;
  columnSort?: ColumnSort;
  pageNumber: number;
}

export const useArtistTracksQuery = ({
  uaid,
  columnSort,
  pageNumber,
}: ArtistTracksQueryProps) => {
  return useQuery({
    enabled: !!uaid,
    queryKey: [
      'artist-tracks',
      uaid,
      pageNumber,
      columnSort?.id,
      columnSort?.desc,
    ],
    queryFn: () => {
      const sortBy = formatArtistTracksSortBy(columnSort);

      return getArtistTracks({
        offset: (pageNumber - 1) * DEFAULT_PAGE_SIZE,
        limit: DEFAULT_PAGE_SIZE,
        uaid,
        sortBy,
      });
    },
  });
};
